import React, { useState } from 'react';
import axios from 'axios';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config';
import 'bootstrap-icons/font/bootstrap-icons.css';
import ImageWithLoader2 from './components/ImageWithLoader2';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import ReactModal from 'react-modal';

function FamilyMembers() {
    
    const { menu, toggleMobileMenu } = useAppLayout();

    const loggedFamilyAdmin = localStorage.getItem("family_admin");
    const loggedInUserId = localStorage.getItem('user_id');
  
    const navigate = useNavigate();
  
    const queryClient = useQueryClient();
  
    const [searchTerm, setSearchTerm] = useState('');
  
    const { data: membersByGeneration, isLoading, isError } = useQuery({
      queryKey: ['familyMembersByGeneration'],
      queryFn: () =>
        axios.get(`${API_URL}/family-members-list`).then((res) => res.data),
      staleTime: 0,
      cacheTime: Infinity,
    });
  
    // Prefer relationship-to-current-user; fall back to other likely fields
  const getRelationLabel = (m) => {
    return (
      m?.relation_to_user ||           // e.g. "Granddaughter"
      m?.relationship_to_user ||       // common alt
      m?.relationToMe ||               // camelCase alt
      m?.relationship ||               // plain "relationship"
      m?.relation ||                   // short form
      m?.kinship ||                    // some APIs use this
      m?.role ||                       // last resort
      ''
    );
  };
  
  
    const formatGeneration = (count) => {
      const suffixes = ['th', 'st', 'nd', 'rd'];
      const v = count % 100;
      return count + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
    };
  
  
    
  
    const calculateAgeDisplay = (dob, dod = null) => {
      if (!dob) return '--';
    
      const birthDate = new Date(dob);
      const endDate = dod ? new Date(dod) : new Date();
    
      let age = endDate.getFullYear() - birthDate.getFullYear();
      const monthDiff = endDate.getMonth() - birthDate.getMonth();
    
      if (
        monthDiff < 0 ||
        (monthDiff === 0 && endDate.getDate() < birthDate.getDate())
      ) {
        age--;
      }
    
      // Guard against invalid or negative ages
      if (age < 0) return '--';
    
      //return dod ? `${age} (deceased)` : age;
  
      return dod
    ? `Died at age ${age} on ${new Date(dod).toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      })}`
    : `Age ${age}`;
  
    };
  
  
  
  
    const [makeAdminModalOpen, setMakeAdminModalOpen] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);
    
    const openMakeAdminModal = (id) => {
      setSelectedUserId(id);
      setMakeAdminModalOpen(true);
    };
  
    const [disableAdminModalOpen, setDisableAdminModalOpen] = useState(false);
  
    const openDisableAdminModal = (id) => {
      setSelectedUserId(id);
      setDisableAdminModalOpen(true);
    };
  
    const handleMakeAdmin = async () => {
      if (!selectedUserId) return;
    
      try {
        const res = await axios.put(
          `${API_URL}/make-member-admin-api`,
          { user_id: selectedUserId },
          { withCredentials: true }
        );
    
        if (res.data.success) {
          toast.success("Admin update successful");
          setMakeAdminModalOpen(false);
          setSelectedUserId(null);
          queryClient.invalidateQueries(['familyMembersByGeneration']);
        } else {
          toast.error(res.data.message || "Failed to update.");
        }
      } catch (error) {
        console.error("Request failed:", error);
        toast.error("Something went wrong.");
      }
    };
    
  
    
  
  
    const handleDisableAdmin = async () => {
      if (!selectedUserId) return;
    
      try {
        const res = await axios.put(
          `${API_URL}/disable-member-admin-api`,
          { user_id: selectedUserId },
          { withCredentials: true }
        );
    
        if (res.data.success) {
          toast.success("Admin update successful");
          setDisableAdminModalOpen(false);
          setSelectedUserId(null);
          queryClient.invalidateQueries(['familyMembersByGeneration']);
        } else {
          toast.error(res.data.message || "Failed to update.");
        }
      } catch (error) {
        console.error("Request failed:", error);
        toast.error("Something went wrong.");
      }
    };
    
  

   

    return (
         
      <div className={`main-wrapper ${menu ? 'slide-nav': ''}`}>
      <Header onMenuClick={(value) => toggleMobileMenu()} />
      <Sidebar />
<ToastContainer />
         <div className='page-wrapper' >
         <div className='content container-fluid' >

         <div className='row'>
              <div className="col-md-6">
              <div className="text-center mb-2">
                      <h5 className="fw-bold text-dark mb-1">
                      <i className="bi bi-heart-fill text-success me-2"></i>
                      Search member
                      </h5>
                       
                    </div>
                </div>
            
                <div className="col-md-6">
                <div
                        className="input-group rounded-pill overflow-hidden shadow-sm"
                        style={{  background: '#fff' }}
                      >
                        <span className="input-group-text bg-white border-0">
                          <i className="bi bi-search text-muted" />
                        </span>

                        <input
          type="text"
          className="form-control border-0 py-2 small"
          placeholder="Search..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ boxShadow: 'none' }}
        />

                        

                        
                      </div> 
                </div>

          </div>

      

{isLoading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ minHeight: '50vh' }}
              >
                <div className="spinner-border text-success" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : isError ? (
              <div className="alert alert-danger text-center">
                Error loading family members.
              </div>
            ) : Object.keys(membersByGeneration || {}).length > 0 ? (
              Object.entries(membersByGeneration)
                .sort(([a], [b]) => a - b)
                .map(([generation_id, members], index) => {
                  const filteredMembers = members.filter((member) =>
                    `${member.name} ${member.last_name}`
                      .toLowerCase()
                      .includes(searchTerm.toLowerCase())
                  );

                  if (filteredMembers.length === 0) return null;

                  return (
                    <div key={generation_id} className="mb-5">
                      {/* Generation Header */}
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <span
                          className="badge rounded-pill px-3 py-2"
                          style={{
                            backgroundColor: '#',
                            backgroundColor: '#75B437',
                            color: '#fff',
                          }}
                        >
                          {formatGeneration(index + 1)} Generation
                        </span>

                        {/* Updated members count badge */}
                        <span
                          className="px-3 py-1 small"
                          style={{
                            backgroundColor: 'rgba(0,128,0,0.06)',
                            color: '#2E7D32',
                            borderRadius: '999px',
                            fontWeight: '500',
                          }}
                        >
                          {filteredMembers.length} members
                        </span>
                      </div>

                      {/* Cards */}
                      <div className="row g-3">
                        {filteredMembers.map((member) => {
                          const imagePath = member.image_name
                            ? `${API_URL}/images/${member.image_name}`
                            : `${API_URL}/images/default.png`;

                          return (
                            <div
                              key={member.user_id}
                              className="col-6 col-md-4 col-lg-3"
                            >
                            <div className="card border-0 shadow-sm rounded h-100 "  >  

                            <div className='clickable-card' onClick={() => navigate('/profile', { state: { memberId: member.id } })}>


                            <ImageWithLoader2
                                                src={`${API_URL}/images/${member.profile_image}`}
                                                placeholder="https://oret.africa/tree/img/placeholder-human-icon.jpg"
                                                fadeDuration={800}
                                                blurAmount={15} 
                                                alt={member.name}

                                                style={{ width: "100%", height: "250px", objectFit: "cover" }}
                                              />
                      </div>

             <div className="card-body" style={{ padding: '10px 8px 10px 12px' }}>
            <h6 className="card-title fw-bold" style={{ marginBottom: '4px', fontSize: '14px' }}>
              {member.name} {member.last_name} 
            </h6>
            
            <p className="small text-muted" style={{ marginBottom: '4px', fontSize: '12px' }}>
              {getRelationLabel(member)}
            </p>
            <div className="d-flex align-items-center justify-content-between small text-muted" style={{ marginBottom: '0', fontSize: '12px' }}>
              <span>
                {calculateAgeDisplay(member.date_of_birth, member.date_of_death)}
              </span>
            </div>

            {member.family_admin === 1 && (
              <span
                  className="badge rounded-pill"
                  style={{
                    background: 'linear-gradient(135deg, #198754 0%, #0f5132 100%)',
                    color: '#fff',
                    fontWeight: 700,
                  }}
                >
                  Family admin
                </span>
                )}


                                  <div className="position-absolute top-0 end-0 m-2">
                                  {loggedFamilyAdmin === "1" && Number(member.id) !== Number(loggedInUserId) && (
                                          <div className="dropdown">

                            
                                          <button
                                  className="btn btn-light btn-sm rounded-circle d-inline-flex align-items-center justify-content-center p-0"
                                  
                                  data-bs-toggle="dropdown" aria-expanded="false" aria-label="Open actions"
                                  style={{ width: 28, height: 28 }}
                                >
                                  ⋮
                                </button>
                                
            
                                            <ul className="dropdown-menu dropdown-menu-end p-1"  >
                                            {member.family_admin !== 1 && (
                                              <li>
                                                <button className="dropdown-item text-success d-flex align-items-center gap-2 py-1 px-2"
                                                        onClick={() => openMakeAdminModal(member.id)} >
                                                          
                                                   Make me admin
                                                </button>
                                              </li>
                                              )}


                                              {member.family_admin !== 0  && member.family_admin !== null &&  (
                                              <li>
                                                <button className="dropdown-item text-success d-flex align-items-center gap-2 py-1 px-2"
                                                        onClick={() => openDisableAdminModal(member.id)} >
                                                          
                                                   Disable admin
                                                </button>
                                              </li>
                                              )}

                                            </ul>
                                            
            
                                          </div>
                                    )}

                                        </div>



                                        

                                        

</div>
                              
                              </div>


                         


                            </div>
                          );
                        })}
                      </div>
                    </div>
                  );
                })
            ) : (
              <p className="text-center text-muted">
                No family members found.
              </p>
            )}



        </div>
        </div>


          <ReactModal
          isOpen={makeAdminModalOpen}
          onRequestClose={() => setMakeAdminModalOpen(false)}
          className="Modal"
         overlayClassName="Overlay"
        >
          <div className="modal-header">
            <h5 className="modal-title">Make Admin</h5>
            <button
              type="button"
              className="btn-close modalCloseButton"
              onClick={() => setMakeAdminModalOpen(false)}
            />
          </div>
        
          <div className="modal-body">
            <p>
              Are you sure you want to make an admin?
            </p>
          </div>
        
          <div className="modal-footer">
            <button className="btn btn-primary" onClick={handleMakeAdmin}>
              Yes, Confirm
            </button>
          </div>
        </ReactModal>
        
        
        
        <ReactModal
          isOpen={disableAdminModalOpen}
          onRequestClose={() => setDisableAdminModalOpen(false)}
          className="Modal"
         overlayClassName="Overlay"
        >
          <div className="modal-header">
            <h5 className="modal-title">Disable Admin</h5>
            <button
              type="button"
              className="btn-close modalCloseButton"
              onClick={() => setDisableAdminModalOpen(false)}
            />
          </div>
        
          <div className="modal-body">
            <p>
              Are you sure you want to disable as an admin?
            </p>
          </div>
        
          <div className="modal-footer">
            <button className="btn btn-primary" onClick={handleDisableAdmin}>
              Yes, Confirm
            </button>
          </div>
        </ReactModal>
        
        

        

        </div>
        
    );
}

export default FamilyMembers;
